import BusinessSupportOverview from '../Components/Support/BusinessSupportOverview';

function BusinessSupportOverviewPage() {
  return <BusinessSupportOverview />;
}

export default BusinessSupportOverviewPage;